module.exports = __webpack_public_path__ + "img/inspiration_05.d96ebd7.webp";